import { getTenantSlugFromHost } from '@/lib/tenantHost'

/**
 * Marketing pages: they need no session and no API, so they render straight
 * away and stay up when the API is down or in maintenance.
 */
const PUBLIC_PATHS = new Set(['/', '/pricing', '/classic', '/v1', '/v2'])

export function isPublicPath(pathname: string = window.location.pathname): boolean {
  // A tenant subdomain has no marketing pages: its "/" waits for the session check.
  if (getTenantSlugFromHost()) return false
  return PUBLIC_PATHS.has(pathname.replace(/\/+$/, '') || '/')
}
